import POIStep from "@/components/POI/POIStep/POIStep.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "PoiExhibition",
  components: { POIStep },
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  data: () => ({
    isLoading: false,
    eventSearch: null,
    foundEvents: []
  }),
  methods: {
    removeExhibition(index) {
      this.editedItem.exhibitions.splice(index, 1);
    },
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    async getEventTitle(eventId) {
      const headers = getTokenHeader();
      const response = await axios.get(
        `${env.events_api_client_url}event/${eventId}`,
        {
          params: {
            principal_id: { $in: [this.selectedPrincipal] }
          },
          headers
        }
      );

      return response.data?.title;
    }
  },
  async mounted() {
    await this.editedItem?.exhibitions?.asyncForEach(
      async (exhibition, index) => {
        const eventTitle = await this.getEventTitle(exhibition.eventId);
        this.editedItem.exhibitions[index].title = eventTitle;
      }
    );
    this.foundEvents = this.editedItem?.exhibitions?.map(e => ({
      title: e.title,
      _id: e.eventId
    }));
  },
  computed: {
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    selectedExhibitionEvents: {
      get() {
        return (
          this.editedItem.exhibitions.map(exhibition => exhibition.eventId) ??
          []
        );
      },
      set(value) {
        if (Array.isArray(value)) {
          value.forEach(val => {
            const foundExhibitions = this.editedItem.exhibitions.find(
              exhibition => exhibition.eventId === val
            );
            if (!foundExhibitions) {
              this.editedItem.exhibitions.push({
                eventId: val,
                room: "",
                floor: ""
              });
            }
          });
        }
      }
    },
    exhibitionEvents() {
      return this.foundEvents;
    }
  },
  watch: {
    async eventSearch(val) {
      if (this.isLoading) return;

      this.isLoading = true;

      const headers = getTokenHeader();
      const { data } = await axios.post(
        `${env.events_api_client_url}event/for_calendar`,
        {
          query: {},
          principal_id: this.$store.state.selectedPrincipal.id,
          s: val,
          distinct: true
        },
        { headers }
      );

      if (data?.results?.length) this.foundEvents = data.results;
      this.isLoading = false;
    }
  }
};
